import { ref, computed } from "vue";

function useIconColor(type = "primary", hover = false, disabled = false) {
  const isDisabled = ref(disabled);
  const isHovered = ref(hover);

  const colorMap = {
    primary: {
      default: "var(--background-color-secondary)",
      hover: "var(--text-color-primary",
      disabled: "var(--background-color-secondary)",
    },
    secondary: {
      default: "var(--text-color-button-secondary)",
      hover: "var(--text-color-primary)",
      disabled: "var(--disabled-color-secondary)",
    },
    tertiary: {
      default: "var(--interactive-color-secondary)",
      hover: "var(--interactive-color-secondary)",
      disabled: "var(--disabled-color-primary)",
    },
    quaternary: {
      default: "var(--background-color-primary)",
      hover: "var(--background-color-primary)",
      disabled: "var(--background-color-quaternary)",
    },
  };

  const state = computed(() => {
    if (isDisabled.value) {
      return "disabled";
    } else if (isHovered.value) {
      return "hover";
    } else {
      return "default";
    }
  });

  const iconColor = computed(() => {
    return colorMap[type][state.value] || colorMap.primary.default;
  });

  return { iconColor };
}

export default useIconColor;
